
import { BaseResourceStorage } from '../../models/base-resource.storage';
import { ContratoTerceirizado } from './contrato-terceirizado.model';
export class ContratoTerceirizadoStorage extends BaseResourceStorage {
  constructor(
    public id?: number,
    public terceirizado?: ContratoTerceirizado,
    public visivel_transparencia?: boolean,
  ) {
    super();
  }
  static converteJson(json: any): ContratoTerceirizadoStorage {
    return Object.assign(new ContratoTerceirizadoStorage(), json);
  }
}